import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class BadwordsService {
  badwords = new BehaviorSubject<any>([]);
  constructor(
    private afs: AngularFirestore) { }

  getBadwords(): Observable<any[]> {
    return this.badwords.asObservable();
  }
  initialize() {
    this.afs.collection('blacklist').ref.get().then(data => {
      let blackList = [];
      data.forEach(snap => {
        blackList.push(snap.data().word);
      })
      this.badwords.next(blackList);

    })
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/badwords.service.ts